import { render } from "./CurrentSessionsForEvent.vue?vue&type=template&id=b57ee894&scoped=true"
import script from "./CurrentSessionsForEvent.vue?vue&type=script&lang=js"
export * from "./CurrentSessionsForEvent.vue?vue&type=script&lang=js"

import "./CurrentSessionsForEvent.vue?vue&type=style&index=0&id=b57ee894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57ee894"]])

export default __exports__